// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1337) return "static/chunks/1337-51ab61d289531104.js";
	if (chunkId === 1071) return "static/chunks/1071-c98da2d61789eb20.js";
	if (chunkId === 5590) return "static/chunks/5590-d2e52b2203448841.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"112":"f3bee17e1c7678b6","2336":"0bba22080054a332","2536":"d6f729543f45ecf5","3340":"d080fe0c8e4d5088","3833":"04faf3755af85cd5","3924":"aac45fd6db4f3ce5","5841":"eddaa530d0d9dcf7","5857":"0a9b97ad9ccb8115","6539":"992a5eae175858e7","7400":"1729a1ad97de217a","8407":"05c67636cd42c0e0","9354":"027d5bac74e6d5c0"}[chunkId] + ".js";
};